export const DELIVERY_INSTRUCTIONS_ICON = "Toing/Cart%20Page/delivery_instructions.png";
